import React, { Component } from 'react'
import { CSSTransitionGroup } from 'react-transition-group'

export default class HeadlineAnimation extends Component {
    constructor(props) {
        super(props)
        this.state = {
            currentText: 0
        }
    }

    startAnimation = () => {
        this.setState({
          currentText: this.state.currentText === this.props.texts.length - 1 ? 0 : this.state.currentText + 1
        })
    }
    
    componentDidMount = () => {
        this.interval = setInterval(this.startAnimation, 2000);
    }

    componentWillUnmount = () => {
        clearInterval(this.interval);
    }

    render() {
        const { texts } = this.props
        return(
            <div>
                <CSSTransitionGroup transitionName="text" transitionEnterTimeout={600} transitionLeaveTimeout={300}>
                    <h1 key={texts[this.state.currentText]}>{texts[this.state.currentText]}</h1>
                </CSSTransitionGroup>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/HeadlineAnimation.js